import * as moment from 'moment';
import { LocalStorageService } from './../utils/local-storage.service';
import constant from './../app.constant';
import * as Leaflet from 'leaflet';
import 'leaflet-routing-machine';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import * as _ from 'lodash';


export class CommonLogicService {

    public localData: any = new LocalStorageService();

    public getUtcOffset() {
        return new Date().getTimezoneOffset() * -1;
    }
    public getCurrentDate() {
        return moment(new Date()).format(constant.DateFormatServerSideWithDateTime);
    }
    // public dateFormaterJsonToString(reqJson: any, format: any) {
    //     let date: any = `${reqJson.year}-${reqJson.month}-${reqJson.day}`
    //     return moment(date, 'YYYY-MM-DD').format(format);
    // }
    // public timeFormaterJsonToString(reqJson: any, format: any) {
    //     let time: any = `${reqJson.hour}-${reqJson.minute}`
    //     return moment(time, 'HH:mm').format(format);
    // }
    // public timeFormaterStringToJson(time: any) {
    //     var reqJson: any = {}
    //     reqJson.hour = parseInt(moment(time, 'HH:mm').format('HH'));
    //     reqJson.minute = parseInt(moment(time, 'mm').format('mm'));
    //     return reqJson;
    // }
    public timeFormaterJsonToString(reqJson: any, format: any) {
        let time: any = `${reqJson.hour}-${reqJson.minute}`
        return moment(time, 'HH:mm').format(format);
    }
    public timeFormaterStringToJson(time: any) {
        var reqJson: any = {}
        reqJson.hour = parseInt(moment(time, 'HH:mm:ss').format('HH'));
        reqJson.minute = parseInt(moment(time, 'HH:mm:ss').format('mm'));
        // reqJson.seconds = parseInt(moment(time, 'HH:mm:ss').format('ss'));
        return reqJson;
    }
    // public dateFormaterStringToJson(date: any) {
    //     var reqJson: any = {}
    //     reqJson.year = parseInt(moment(date, 'YYYY-MM-DD').format('YYYY'));
    //     reqJson.month = parseInt(moment(date, 'YYYY-MM-DD').format('MM'));
    //     reqJson.day = parseInt(moment(date, 'YYYY-MM-DD').format('DD'));
    //     return reqJson;
    // }
    public convertUtcTime(date: any) {
        // var reqJson: any = {}
        return moment.utc(date, constant.DateFormatServerSideWithDateTime).local().format('lll');
    }
    public convertUtcDate(date: any, format: string = constant.DateFormatHtml) {
        // var reqJson: any = {}
        return moment.utc(date, constant.DateFormatServerSideWithDateTime).local().format(format);
    }
    public convertdateTime(date: any) {
        var reqJson: any = {}
        return reqJson.DateTime = moment(date, constant.DateFormatServerSideWithDateTime).format('lll');
    }
    public convertdate(date: any) {
        var reqJson: any;
        return reqJson = moment(date).format(constant.DateFormat);
    }
    // public convertPickUpdateTime(date: any) {
    //     var reqJson: any = {}
    //     return reqJson.DateTime = moment(date).format('DD-MM-YYYY HH:mm');
    // }
    public isObject(value: any) {
        return typeof value === 'object';
    }

    // public dateFormatechanges(date: any, format: any) {
    //     return moment(date, format.fromFormat ? format.fromFormat : null).format(format.toFormat ? format.toFormat : null);
    // }
    public givenDateTimeAndOffsetToChangeUtcTime(dateTime: any) {
        var reqUtcOffset = -1 * this.getUtcOffset();
        var utcTime = moment.utc(dateTime, constant.datePickerFormat).utcOffset(reqUtcOffset).format(constant.DateFormatServerSideWithDateTime);
        return utcTime;
    }

    public orderFindAgency(order: any, roleId: any) {
        var reqJson: any = {}
        switch (roleId) {
            case 1:
            case 2:
                if (order.Agency) {
                    reqJson.agencyName = order.Agency.full_name;
                } else if (order.MasterAgency) {
                    reqJson.agencyName = order.MasterAgency.full_name;
                }
                // else if (order.VendorAgency) {
                //     reqJson.agencyName = order.VendorAgency.full_name;
                // }
                else if (order.OrderFromUser) {
                    if (order.order_from_role_id == constant.RoleId.orderingPartner)
                        reqJson.agencyName = order.OrderFromUser.full_name;
                } else {
                    reqJson.agencyName = '--'
                }
                break;
            case 4:
                if (order.Agency) {
                    reqJson.agencyName = order.Agency.full_name;
                } else if (order.MasterAgency) {
                    reqJson.agencyName = order.MasterAgency.full_name;
                } else if (order.OrderFromUser) {
                    if (order.order_from_role_id == constant.RoleId.orderingPartner)
                        reqJson.agencyName = order.OrderFromUser.full_name;
                    else
                        reqJson.agencyName = '--';
                } else {
                    reqJson.agencyName = '--'
                }
                break;
            default:
                reqJson.agencyName = '--'
                break;

        }
        return reqJson.agencyName;
    }


    public latLongToCalculateDistanceViaHaversineFormula(data: any) {

        function deg2rad(deg: any) {
            return Number(deg) * (Math.PI / 180)
        }
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(Number(data.lat2) - Number(data.lat1));  // deg2rad below
        var dLon = deg2rad(Number(data.long2) - Number(data.long1));
        var a = (Math.sin(dLat / 2) * Math.sin(dLat / 2)) +
            (Math.cos(deg2rad(data.lat1)) * Math.cos(deg2rad(data.lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2));
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    public calculateTimeFromDistanceAndAvarageSpeed(data: any) {
        //distance = speed * time;
        let distance: any = data.distance * 1000; // converted to meter
        let speed: any = data.avarageSpeed * 1000 / 60
        return distance / speed;  // return time minutes
    }
    async drawLineInMapUsingleaflet(reqMap: Leaflet.Map, data: any, callback: Function) {
        var waypointss = [
            Leaflet.latLng(Number(data.lat1 || 0), Number(data.long1 || 0)),
            Leaflet.latLng(Number(data.lat2 || 0), Number(data.long2 || 0))
        ];
        var route: any = Leaflet.Routing.control({
            waypoints: [Leaflet.latLng(Number(data.lat1 || 0), Number(data.long1 || 0)), Leaflet.latLng(Number(data.lat2 || 0), Number(data.long2 || 0))],

            addWaypoints: false, fitSelectedRoutes: false, show: false, lineOptions: {
                extendToWaypoints: true, missingRouteTolerance: 1, missingRouteStyles: [], styles: [{
                    color: `#${data.outerLineColour ? data.outerLineColour : '0000FF'}`,
                    opacity: 0.8,
                    weight: 6
                }, {
                    color: `#${data.innerLineColour ? data.innerLineColour : '0000FF'}`,
                    opacity: 1,
                    weight: 2
                }]
            }, plan: Leaflet.Routing.plan(waypointss, {
                createMarker: function (i, wp) {
                    return null
                },

            }),
        }).addTo(reqMap);

        var summary;

        await route.on('routesfound', function (e) {
            var routes = e.routes;
            summary = routes[0].summary;
            summary.totalDistance = summary.totalDistance / 1000;
            summary.totalTime = Math.round(summary.totalTime % 3600 / 60);
            // alert distance and time in km and minutes
            callback(summary)
            // alert('Total distance is ' + summary.totalDistance / 1000 + ' km and total time is ' + Math.round(summary.totalTime % 3600 / 60) + ' minutes');
        });
    }
    public roleWiseOrderStatus(data: any) {
        switch (data) {
            case 1:
            case 2:
            case 3:
                return data = [{ order_status_name: 'Pending', order_status_id: 2, disabled: false },
                { order_status_name: 'Assigned', order_status_id: 3, disabled: false },
                { order_status_name: 'Arrived at pickup', order_status_id: 11, disabled: false },
                { order_status_name: 'Picked Up', order_status_id: 4, disabled: false },
                { order_status_name: 'Out for delivery', order_status_id: 9, disabled: false },
                { order_status_name: 'Return', order_status_id: 13, disabled: false },
                { order_status_name: 'Arrived', order_status_id: 8, disabled: false },
                { order_status_name: 'Delivered', order_status_id: 5, disabled: false },
                { order_status_name: 'Cancelled', order_status_id: 6, disabled: false },
                { order_status_name: 'RTO-Delivered', order_status_id: 14, disabled: false },
                { order_status_name: 'RTO-Disposed', order_status_id: 16, disabled: false },
                    // { order_status_name: 'Undelivered', order_status_id: 10, disabled: false }
                    // { order_status_name: 'Undelivered', order_status_id: 10, disabled: false }
                ];
            case 4:
            case 5:
            case 10:
                return data = [{ order_status_name: 'Pending', order_status_id: 2, disabled: false },
                { order_status_name: 'Assigned', order_status_id: 3, disabled: false },
                { order_status_name: 'Arrived at pickup', order_status_id: 11, disabled: false },
                { order_status_name: 'Picked Up', order_status_id: 4, disabled: false },
                { order_status_name: 'Out for delivery', order_status_id: 9, disabled: false },
                { order_status_name: 'Return', order_status_id: 13, disabled: false },
                { order_status_name: 'Arrived', order_status_id: 8, disabled: false },
                { order_status_name: 'Delivered', order_status_id: 5, disabled: false },
                { order_status_name: 'Cancelled', order_status_id: 6, disabled: false },
                { order_status_name: 'RTO-Delivered', order_status_id: 14, disabled: false },
                { order_status_name: 'RTO-Disposed', order_status_id: 16, disabled: false },
                    // { order_status_name: 'System Finished', order_status_id: 15, disabled: false }
                ];
            case 6:
                return data = [{ order_status_name: 'Pending', order_status_id: 2 },
                { order_status_name: 'Assigned', order_status_id: 3 },
                { order_status_name: 'Arrived at pickup', order_status_id: 11 },
                { order_status_name: 'Picked Up', order_status_id: 4 },
                { order_status_name: 'Out for delivery', order_status_id: 9 },
                { order_status_name: 'Return', order_status_id: 13 },
                { order_status_name: 'Arrived', order_status_id: 8 },
                { order_status_name: 'Delivered', order_status_id: 5 },
                { order_status_name: 'Cancelled', order_status_id: 6 },
                { order_status_name: 'RTO-Delivered', order_status_id: 14 },
                { order_status_name: 'RTO-Disposed', order_status_id: 16, disabled: false },
                    // { order_status_name: 'System Finished', order_status_id: 15 }
                ];
            case 'ondc':
                return data = [
                    { order_status_name: 'Accepted', order_status_id: 3 },
                    { order_status_name: 'In-progress', order_status_id: 8 },
                    { order_status_name: 'Completed', order_status_id: 5 },
                    { order_status_name: 'Cancelled', order_status_id: 6 }];
            default:
                return data = [{ order_status_name: 'Pending', order_status_id: 2 },
                { order_status_name: 'Assigned', order_status_id: 3 },
                { order_status_name: 'Arrived at pickup', order_status_id: 11 },
                { order_status_name: 'Picked Up', order_status_id: 4 },
                { order_status_name: 'Out for delivery', order_status_id: 9 },
                { order_status_name: 'Return', order_status_id: 13 },
                { order_status_name: 'Arrived', order_status_id: 8 },
                { order_status_name: 'Delivered', order_status_id: 5 },
                { order_status_name: 'Cancelled', order_status_id: 6 },
                { order_status_name: 'RTO-Delivered', order_status_id: 14 },
                { order_status_name: 'RTO-Disposed', order_status_id: 16, disabled: false },
                    // { order_status_name: 'System Finished', order_status_id: 15 }
                ];
        }
    }
    public orderUserData(order: any) {
        var userName: any;
        if (order?.vendor_user_id) {
            return userName = (order?.Vendor?.full_name) ? (order?.Vendor?.full_name) + ' (Customer)' : null;
        } else if (order?.agency_user_id) {
            return userName = (order?.Agency?.full_name) ? (order?.Agency?.full_name) + ' (Agency)' : null;
        } else if (order?.master_agency_user_id) {
            return userName = (order?.MasterAgency?.full_name) ? (order?.MasterAgency?.full_name) + ' (Master Agency)' : null;
        } else if (order?.vendor_agency_user_id) {
            return userName = (order?.VendorAgency?.full_name) ? (order?.VendorAgency?.full_name) + ' (Vendor Agency)' : null;
        } else {
            return userName = '--'
        }
    }
    public WhatsAppChatLink(order) {
        var link: any;
        if (order?.DeliveryPartner && order?.DeliveryPartner?.whatsapp_channel) {
            return link = (order?.DeliveryPartner?.whatsapp_channel) ? (order?.DeliveryPartner?.whatsapp_channel) : null;
        } else if (order?.Vendor?.whatsapp_channel) {
            return link = (order?.Vendor?.whatsapp_channel) ? (order?.Vendor?.whatsapp_channel) : null;
        } else if (order?.Agency?.whatsapp_channel) {
            return link = (order?.Agency?.whatsapp_channel) ? (order?.Agency?.whatsapp_channel) : null;
        } else if (order?.MasterAgency?.whatsapp_channel) {
            return link = (order?.MasterAgency?.whatsapp_channel) ? (order?.MasterAgency?.whatsapp_channel) : null;
        } else if (order?.VendorAgency?.whatsapp_channel) {
            return link = (order?.VendorAgency.whatsapp_channel) ? (order?.VendorAgency.whatsapp_channel) : null;
        } else {
            return link = ''
        }
    }
    public pickupCityNameShow(data: any) {
        if (!_.isEmpty(data)) {
            if (data?.sublocality_level_2) {
                return data?.sublocality_level_2;
            } else if (data?.sublocality_level_1) {
                return data?.sublocality_level_1;
            } else if (data?.locality) {
                return data?.locality;
            } else if (data?.district_short_name) {
                return data?.district_short_name;
            } else if (data?.district_name) {
                return data?.district_name;
            } else {
                return data?.city_name
            }
        }
    }
    public deliveryCityNameShow(data: any) {
        if (!_.isEmpty(data)) {
            if (data?.sublocality_level_2) {
                return data?.sublocality_level_2;
            } else if (data?.sublocality_level_1) {
                return data?.sublocality_level_1;
            } else if (data?.locality) {
                return data?.locality;
            } else if (data?.district_short_name) {
                return data?.district_short_name;
            } else if (data?.district_name) {
                return data?.district_name;
            } else {
                return data?.city_name
            }
        }
    }
    public differentciateDateTag(fromDate: any, toDate: any) {
        var from_date_time: any = new Date(fromDate);
        var to_date_time: any = new Date(toDate);
        const oneDay = 24 * 60 * 60 * 1000;
        var diffDays = Math.ceil(Math.abs(from_date_time - to_date_time) / oneDay);
        return diffDays;
    }
    public pickupDateTimeChecked(date: any, orderStatusId: any) {

        let pickupDateTime = moment(date).add(5, 'minutes').format(constant.DateFormatServerSideWithDateTime)
        var currentDate = moment(new Date()).format(constant.DateFormatServerSideWithDateTime)
        if ([constant.OrderStatusId.pending, constant.OrderStatusId.assigned, constant.OrderStatusId.arrivedAtPickup].includes(orderStatusId)) {
            if (moment(currentDate).isAfter(pickupDateTime)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }

    }
    public etaTimeCaculate(orderData: any) {
        if (!_.isEmpty(orderData)) {
            let order = JSON.parse(JSON.stringify(orderData))
            if (!_.isEmpty(order.DeliveryPartner) && !_.isEmpty(order?.OrderDetail?.delivery_partner_rider_dtl)) {
                order.DeliveryStaff = {
                    full_name: order?.OrderDetail?.delivery_partner_rider_dtl?.full_name,
                    phone: order?.OrderDetail?.delivery_partner_rider_dtl?.phone,
                    DsCurrentLocation: {
                        lat: order?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.lat,
                        long: order?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.long
                    }
                }
            }
            let reqObj: any = {};
            if ([constant.OrderStatusId.outForDelivery, constant.OrderStatusId.pickedUp, constant.OrderStatusId.arrived].includes(order.order_status_id)) {
                reqObj = {
                    lat1: Number(order?.DeliveryStaff?.DsCurrentLocation?.lat || 0),
                    long1: Number(order?.DeliveryStaff?.DsCurrentLocation?.long || 0),
                    lat2: Number(order?.delivery_lat || 0),
                    long2: Number(order?.delivery_long || 0)
                }
            } else if ([constant.OrderStatusId.assigned, constant.OrderStatusId.arrivedAtPickup].includes(order?.OrderStatus?.order_status_id)) {
                reqObj = {
                    lat1: Number(order?.DeliveryStaff?.DsCurrentLocation?.lat || 0),
                    long1: Number(order?.DeliveryStaff?.DsCurrentLocation?.long || 0),
                    lat2: Number(order?.pickup_lat || 0),
                    long2: Number(order?.pickup_long || 0)
                }
            } else {
                return '--';
            }
            if (order?.DeliveryStaff?.DsCurrentLocation?.lat != 0 && order?.DeliveryStaff?.DsCurrentLocation?.long != 0) {
                let reqKm: any = commonLogics.latLongToCalculateDistanceViaHaversineFormula(reqObj);
                let time: any = commonLogics.calculateTimeFromDistanceAndAvarageSpeed({
                    distance: reqKm,
                    avarageSpeed: 30
                });
                let hours = Math.floor(time / 60);
                let minutes = Math.floor(time % 60);
                if ([constant.OrderStatusId.assigned, constant.OrderStatusId.arrivedAtPickup].includes(order?.OrderStatus?.order_status_id)) {
                    return 'To pickup ' + (hours ? hours + 'hrs' : '') + ': ' + minutes + ' mins';
                } else if ([constant.OrderStatusId.pickedUp, constant.OrderStatusId.outForDelivery, constant.OrderStatusId.arrived].includes(order?.OrderStatus?.order_status_id)) {
                    return 'To delivery ' + (hours ? hours + 'hrs' : '') + ': ' + minutes + ' mins';
                } else {
                    return '--';
                }
            } else {
                return '--';
            }
        }
    }
    public deliveryStaffDetails(order: any) {
        if (!_.isEmpty(order.DeliveryPartner) && !_.isEmpty(order?.OrderDetail?.delivery_partner_rider_dtl)) {
            let deliveryStaffDetails = {
                full_name: order?.OrderDetail?.delivery_partner_rider_dtl?.full_name,
                phone: order?.OrderDetail?.delivery_partner_rider_dtl?.phone,
                DsCurrentLocation: {
                    lat: order?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.lat,
                    long: order?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.long
                }
            }
            return deliveryStaffDetails;
        }
    }
    public minRoundOff(value: any) {
        // if (Number(value) < 1) return 1;
        if (Number(value) == 0) return 0;
        if (Number(value) > 0 && Number(value) < 1) return 1;

        return Math.round(Number(value));
    }


    public riderIcon(color: any) {
        let riderIcon = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="45.1px" height="59.5px" viewBox="0 0 45.1 59.5" style="enable-background:new 0 0 45.1 59.5;" xml:space="preserve">
            <path fill="#${color}" d="M45.1,22.6C45.1,10.1,35,0,22.6,0S0,10.1,0,22.6c0,11.1,8.1,20.4,18.6,22.2h0l3.9,14.7l4-14.7h0
            C37.1,42.9,45.1,33.7,45.1,22.6z"/>
            <circle fill="#ffffff" cx="22.6" cy="22.7" r="18.3"/>
            <g>
            <path fill="#${color}" d="M31.9,28.2c0.5-0.1,0.9-0.1,1.4-0.1L32,27.6l-1-1.3l-1-1.2l0.3-0.1l-0.9-1.2l-0.3,0.1l0,0.1l-0.8-1.1l-0.2-0.3
            l0.7-1.6l-0.5,0l-0.1,0.1l-0.6,0.1l-0.4-0.1l-1-0.1L26,21.4l0,0c-1.7-1-4-2.5-5-4.3c-0.2-0.4-0.7-0.5-1.1-0.3c0,0,0,0,0,0
            c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2,0,0.4,0.1,0.6c1.3,2.2,3.2,3.5,5.6,4l0,0h0.2c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.2,0,0.2,0l1.4,1
            l1,5.2l-1.2,1.7c0,0,0-0.1,0-0.1c0-0.4-0.2-0.7-0.7-0.8l-0.6,0l-1-4.4c-0.2-0.8-0.8-1.3-1.6-1.4c-0.6-0.1-1.1-0.2-1.7-0.2
            c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.2-0.4-0.1-0.6c0.1-0.5,0.2-0.9,0.3-1.4c-0.9-0.7-1.6-1.5-2.2-2.5c-0.1-0.2-0.2-0.5-0.1-0.8
            c0.1-0.3,0.3-0.5,0.5-0.6c0,0,0,0,0,0c0.5-0.3,1.1-0.1,1.4,0.4c0.2,0.3,0.4,0.7,0.7,1c0-0.3,0-0.7-0.1-0.9c-0.1-0.5-0.5-0.9-1-1
            c-0.5-0.2-1-0.1-1.4,0.2c-1.6,1.2-2,4.3-1.5,7c0.2,0.9,0.9,1.6,1.8,1.8c0.9,0.1,1.9,0.3,2.8,0.4c0.4,0.1,0.8,0.3,1,0.7l1.5,2.7
            c-0.1,0-0.3,0.1-0.4,0.2c-0.2,0.1-0.2,0.3-0.2,0.5v0.2c0,0.1,0.1,0.2,0.2,0.2h2.1l-4.6,0.6L21.2,29l0.8-1.9l0.9-1.3l-0.4-0.1
            l-2.8-0.4l-0.4-0.1H15L14.5,26l0.1-0.2v0l0,0l-0.1,0l-3.5-2h4.9c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.4-0.3,0.5l0.2,0h3
            c-0.4-0.3-0.7-0.8-0.8-1.4h-0.1h-0.3h-0.4h-0.7h-5.8c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.1,0.2l0.4,0.3l3.4,1.9L12.9,28l0.2,0
            l0,0.7h-0.9c-0.4,0-0.7,0.3-0.7,0.7V31h0.9c0.6-1.6,2.2-2.7,4-2.7c2.2,0,4,1.6,4.3,3.7v0l8.2-0.7C29.2,29.8,30.4,28.5,31.9,28.2z
            M18.4,27l-0.2,0.1h-1.8L16.3,27l0-0.1H17l0.1-0.1l-0.1-0.1h-0.7l0-0.1h0.3l0.1-0.1l-0.1-0.1h-0.3l0.1-0.2h0.6l0.1-0.1l-0.1-0.1
            h-0.6l0-0.1L17,26h1.8l0.1,0.1L18.4,27z"/>
            <path fill="#${color}" d="M33.8,31.6c0.1,0.2,0.2,0.4,0.2,0.7c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.1,0-0.2,0-0.2l-1.4,0.3
            c0,1.4,1.2,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5c0-0.4-0.1-0.7-0.2-1L33.8,31.6z"/>
            <path fill="#${color}" d="M16.4,33.4c-0.6,0-1.1-0.5-1.1-1.1h-1.4c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5h-1.4
            C17.5,33,17,33.4,16.4,33.4z"/>
            <path fill="#${color}" d="M20.8,15.6c0.1,0,0.2,0,0.4,0c0.4-0.1,0.7-0.2,0.9-0.5c0.2-0.3,0.3-0.6,0.3-1.1c0-0.2,0-0.4-0.1-0.7
            c0-0.3,0.1-0.4,0.3-0.4c0.1,0,0.3,0,0.5,0c0.2,0,0.4,0,0.6,0c-0.1-0.5-0.4-0.9-0.8-1.2c-0.4-0.3-0.9-0.5-1.4-0.5
            c-0.6,0-1.2,0.3-1.6,0.7c-0.4,0.4-0.7,1-0.7,1.6c0,0.5,0.2,1,0.4,1.3C20,15.2,20.4,15.5,20.8,15.6z M20.4,13.7L20.4,13.7l0.4-0.1
            c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1h-0.4l0-0.1h0.2c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0h-0.2l0.1-0.2h0.4c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0
            h-0.4l0-0.1c0-0.1,0.1-0.1,0.1-0.1h1c0.1,0,0.1,0,0.1,0.1l-0.2,0.6c0,0.1-0.1,0.1-0.1,0.1h-1C20.4,13.8,20.4,13.7,20.4,13.7z"/>
            <path fill="#${color}" d="M22.2,15.2c-0.1,0.2-0.3,0.3-0.5,0.4c1.1-0.1,2-1,2-2.1c0-0.1,0-0.3,0-0.4c-0.2,0-0.3,0-0.5,0
            c-0.2,0-0.4,0-0.5,0c-0.1,0-0.2,0-0.1,0.2c0,0.2,0.1,0.5,0.1,0.7C22.6,14.4,22.5,14.9,22.2,15.2z"/>
            <path fill="#${color}" d="M16.4,28.6c-2,0-3.7,1.5-4,3.5h8C20.1,30.1,18.4,28.6,16.4,28.6z"/>
            <path fill="#${color}" d="M32,28.4c-1.8,0.4-3,2.1-2.9,3.9l7.2-1.6C35.6,29,33.8,28,32,28.4z"/>
            <rect x="14" y="16" fill="#${color}" width="3.3" height="3.3"/>
            <rect x="10.3" y="16" fill="#${color}" width="3.3" height="3.3"/>
            <rect x="10.3" y="19.8" fill="#${color}" width="3.3" height="3.3"/>
            <rect x="14" y="19.8" fill="#${color}" width="3.3" height="3.3"/>
            <rect x="9.9" y="14.8" fill="#${color}" width="7.9" height="0.9"/>
            </g>
            </svg`
        return riderIcon;
    }
    public vendorIcon() {
        let vendorIcon = `
        <svg width="64" height="64" viewBox="0 0 386 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="29" y="31" width="329" height="329" rx="164.5" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M302.511 184.377C302.53 184.717 302.554 185.047 302.554 185.377C302.544 192.254 300.182 198.92 295.861 204.27C291.541 209.619 285.52 213.331 278.8 214.788L273.936 215.84V320.287C273.928 327.727 270.97 334.861 265.711 340.123C260.451 345.385 253.319 348.347 245.879 348.358H140.279C132.839 348.346 125.707 345.385 120.448 340.122C115.189 334.86 112.231 327.727 112.223 320.287V215.84L107.363 214.788C100.642 213.331 94.6207 209.62 90.2985 204.27C85.9764 198.921 83.6128 192.254 83.6 185.377C83.5974 185.063 83.6114 184.75 83.642 184.438L91.379 101.377V101.358L91.413 101.127C91.7568 98.1255 93.1933 95.3556 95.4485 93.3453C97.7037 91.335 100.62 90.2251 103.641 90.227H282.521C285.546 90.2292 288.465 91.3431 290.722 93.3569C292.979 95.3707 294.418 98.1438 294.764 101.149V101.276V101.295L302.515 184.375L302.511 184.377ZM111.073 110.709L104.062 185.948L104.152 186.637C104.471 188.942 105.61 191.055 107.36 192.589C109.111 194.122 111.355 194.974 113.682 194.987H133.733V175.857C133.76 173.159 134.85 170.58 136.768 168.682C138.685 166.783 141.274 165.718 143.972 165.718C146.671 165.718 149.26 166.783 151.177 168.682C153.095 170.58 154.185 173.159 154.212 175.857V194.987H182.831V175.857C182.858 173.159 183.948 170.58 185.866 168.682C187.783 166.783 190.372 165.718 193.07 165.718C195.769 165.718 198.358 166.783 200.275 168.682C202.193 170.58 203.283 173.159 203.31 175.857V194.987H231.933V175.857C231.933 173.141 233.012 170.537 234.932 168.616C236.853 166.696 239.457 165.617 242.173 165.617C244.889 165.617 247.493 166.696 249.414 168.616C251.334 170.537 252.413 173.141 252.413 175.857V194.987H272.464C274.794 194.974 277.041 194.121 278.792 192.583C280.543 191.045 281.68 188.927 281.994 186.618L282.084 185.939L275.073 110.709H111.073ZM132.7 320.287C132.71 322.295 133.51 324.218 134.929 325.639C136.347 327.06 138.268 327.864 140.276 327.878H158.968V280.657C158.979 276.349 160.696 272.22 163.742 269.174C166.789 266.127 170.918 264.411 175.226 264.4H210.92C215.23 264.406 219.363 266.12 222.411 269.167C225.459 272.215 227.175 276.347 227.182 280.657V327.878H245.874C247.882 327.867 249.805 327.063 251.224 325.641C252.643 324.22 253.443 322.295 253.451 320.287V215.467H132.7V320.287ZM206.708 327.878V284.878H179.448V327.878H206.708ZM193.073 512.6C194.648 512.6 196.202 512.237 197.613 511.538C199.025 510.839 200.256 509.824 201.211 508.571L333.224 335.5C363.97 295.182 384.474 245.22 385.884 194.179C386.644 166.721 381.912 139.462 370.91 114.231C361.69 93.2441 348.595 74.1845 332.31 58.052C295.31 21.2571 245.25 0.603027 193.069 0.603027C140.888 0.603027 90.828 21.2571 53.828 58.052C37.5527 74.1852 24.4582 93.2366 15.228 114.212C4.24297 139.44 -0.50003 166.718 0.26197 194.176C1.67197 245.217 22.176 295.176 52.921 335.497L184.935 508.569C185.891 509.821 187.122 510.836 188.533 511.534C189.945 512.233 191.498 512.597 193.073 512.598V512.6Z" fill="url(#paint0_linear_28_231)"/>
            <defs>
            <linearGradient id="paint0_linear_28_231" x1="95.82" y1="309.209" x2="314.808" y2="127.6" gradientUnits="userSpaceOnUse">
            <stop stop-color="#9E489B"/>
            <stop offset="0.53" stop-color="#F15B52"/>
            <stop offset="1" stop-color="#FCB322"/>
            </linearGradient>
            </defs>
        </svg>
`
        return vendorIcon;

    }
    public minimumError(fieldName: any, Value: any) {
        return `${fieldName} must be at least ${Value} characters long`
    }
    public maximumError(fieldName: any, Value: any) {
        return `${fieldName} should be no longer than ${Value} characters`
    }
    public maxAllowValueError(Value: any) {
        return `Please enter a value less than ${Value}`
    }

}

let commonLogics = new CommonLogicService();
export default commonLogics;
